import { fixNaN } from './fixNaN'

export const formatToReal = (value) => {
  return `R$ ${fixNaN(value).toFixed(2).replace('.', ',')}`
}
